// @flow strict
import * as React from 'react'
import { type ContentfulNode } from '@mondough/contentful'
import {
  getHeroSectionFieldsFromContentful,
  getTextAndImageSectionFieldsFromContentful,
  getTriptychSectionFieldsFromContentful,
  getEmailSignUpFormFieldsFromContentful,
  getMarkdownSectionFieldsFromContentful,
  getCTASectionFieldsFromContentful,
  getSubtitleSectionFieldsFromContentful,
} from './extractContentfulFields'
import USAHero from '../components/theme-usa/USAHeroSection'
import USATextAndImage from '../components/theme-usa/USATextAndImage'
import USASubtitleSection from '../components/theme-usa/USASubtitleSection'

export const usaSubtitleSection = (node: ContentfulNode) => {
  const { subtitle, blurb } = getSubtitleSectionFieldsFromContentful(node)
  return <USASubtitleSection subtitle={subtitle} blurb={blurb} />
}
export const usaHero = (node: ContentfulNode) => {
  const {
    title,
    description,
    imageUrls,
    cta,
  } = getHeroSectionFieldsFromContentful(node)
  return (
    <USAHero
      title={title}
      description={description}
      imageUrls={imageUrls}
      cta={cta}
    />
  )
}
export const usaTextAndImage = (node: ContentfulNode) => {
  const {
    title,
    description,
    imageUrls,
    imageAlts,
    reverse,
    cta,
  } = getTextAndImageSectionFieldsFromContentful(node)
  return (
    <USATextAndImage
      title={title}
      description={description}
      imageUrls={imageUrls}
      imageAlts={imageAlts}
      reverse={reverse}
      cta={cta}
    />
  )
}
export const usaTriptych = (node: ContentfulNode) => {
  const props = getTriptychSectionFieldsFromContentful(node)
  return <div {...props} />
}
export const usaEmailSignUpForm = (node: ContentfulNode) => {
  const props = getEmailSignUpFormFieldsFromContentful(node)
  return <div {...props} />
}
export const usaMarkdownSection = (node: ContentfulNode) => {
  const props = getMarkdownSectionFieldsFromContentful(node)
  return <div {...props} />
}
export const usaCTASection = (node: ContentfulNode) => {
  const props = getCTASectionFieldsFromContentful(node)
  return <div {...props} />
}
